const GasSymbologyIcon = ({ ...props }) => {
    return (
        <svg
            width="24"
            height="12"
            viewBox="0 0 24 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect width="4" height="12" fill="#FF0000" />
            <rect x="4" width="4" height="12" fill="#00D9D7" />
            <rect x="8" width="4" height="12" fill="#45FF1D" />
            <rect x="12" width="4" height="12" fill="#DA7D00" />
            <rect x="16" width="4" height="12" fill="#FF66F7" />
            <rect x="20" width="4" height="12" fill="#FF9300" />
        </svg >
    );
};

export default GasSymbologyIcon;
